import React from 'react' 

const About = () => {
    return (
        <div className="container-1">
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 className="center">My story 📚</h1>
            <img className ="skylermessageshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2044.png"></img>
            <h2 className="about-h2text">Wanted to be Pablo Picasso lol... 🎨</h2>

            <p className="about-ptext-leftalign">I started drawing at 5, then explored different mediums as tech evolved. 
            <br/>
            <br/>
            But first - check out some of the traditional artwork I’ve created over the years, ranging from colored pencil realism to acrylic portraits:</p>
            <img className="skylerartwork" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2045%20(1).png"></img>

            <h2 className="about-h2text">Becoming a ✨ pixel pusher ✨</h2>
            <p className="about-ptext-leftalign">
            In high school, I fell in love with designing anything & everything on Figma.   </p>
            
        

            <div class="allabout-columns">
            <div class="about-column-onleft">
                <img className = "about-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2046%20(1).png"></img>
            </div>
            <div class="about-column-onright">
            <p className="about-ptext-leftalign">Mobile apps. Websites. Pitch decks. 
            <br/>
            <br/>
            Whether it be for science research competitions or social media posts, this tool became my right-hand bestie.
            <br/>
            <br/>
            P.S. This site was first designed in Figma!
            </p>
            </div>
            </div>
            
            

            <br/>

            <h2 className="about-h2text">print('hey, world of coding!') 👩🏻‍💻</h2>
            
            <div class="allabout-columns2">
            <div class="about-column-onleft2">
            <p className="about-ptext-leftside">
            I started *really* coding the summer before college, where I’d watch web development YouTube tutorials by freeCodeCamp.
            </p>
            </div>
            <div class="about-column-onright2">
            <img className = "about-pic2" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2061.png"></img>
            </div>
            </div>
            
            <br/>
            
            <div class="allabout-columns">
            <div class="about-column-onleft">
                <img className = "about-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Ellipse%2021%20(1).png"></img>
            </div>
        
            <div class="about-column-onright">
            <p className="about-ptext-leftalign">
            
            Met my mentor, <a href="https://www.linkedin.com/in/lexusdavis/" className="revuelinks">Lexus Davis</a>, who helped me find clarity in tech and motivated me to develop 3 coding projects. 
            <br/>
            <br/>
            Thank you to <a href="https://outintech.com/" className="revuelinks">Out in Tech</a> for connecting us! Go check out their incredible Slack community, events, and other opportunities.
            </p>
            </div>
            </div>
            <br/>
            
            <div class="allabout-columns2">
            <div class="about-column-onleft2">
            <p className="about-ptext-leftside">
            Then entered hackathons and eventually landed my first win at the QImpacts Hackathon!
            <br/>
            <br/>
            Read more about the project and my experience <a href="https://devpost.com/software/unicorn-stack" className="revuelinks">here</a>.            </p>
            </div>
            <div class="about-column-onright2">
            <img className="about-pic2" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2032%20(2).png"></img>
            </div>
            </div>
            <br/>
            
            <div class="allabout-columns">
            <div class="about-column-onleft">
                <img className = "about-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2032%20(3).png"></img>
            </div>
            <div class="about-column-onright">
            <p className="about-ptext-leftalign">
            Did an incredible internship at <a href="https://bit.ly" className="revuelinks">Bitly</a>, where I dove into APIs, dynamic programming with React, and more!
            <br/>
            <br/>
            Read more about the intern project <a href="https://github.com/bitly/sprinterns2022" className="revuelinks">here</a> or watch a day in the life <a href="https://youtu.be/Vfck2ivMA5E" className="revuelinks">here</a>.
            </p>
            </div>
            </div>


            <h2 className="about-h2text">Now filming my journey on... 🎥</h2>
            <div class="allabout-columns2">
            <div class="about-column-onleft2">
            <p className="about-ptext-leftside-youtube">
            ...YouTube! (join the notification squad LET'S GOOO 🔔)
            <br/>
            <br/>
            I grew up watching YouTubers like Joey Graceffa, Quackity, and many more who have inspired me to finally start my <a href="https://www.youtube.com/c/SkylerBasco" className="revuelinks">tech channel</a>!
            </p>
            </div>
            <div class="about-column-onright2">
            <img className = "about-pic2" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2018%20(1).png"></img>
            </div>
            </div>
          <br/>
            <div className="center">
            <a
                className="general-button"
                href="https://www.youtube.com/c/SkylerBasco"
                target="_blank"
                rel="noopener noreferrer"
            >
                Subscribe to my channel!
            </a>
            </div>
            <br/>
        </div>
    )
}

export default About